import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITION_SIGNER_RECEIPT_DIGEST_EMAIL_PROMOTION_COUNT = defineFcm(
	'promoted_petition_signer_receipt_digest_email_promotion_count',
)
	.asNumber()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description:
			'Defines the number of promoted petitions that should be included in the footer of the signature receipt digest email',
		import: false,
	});
